import { render, staticRenderFns } from "./liftrelay.vue?vue&type=template&id=bc2d36a8&scoped=true&"
import script from "./liftrelay.vue?vue&type=script&lang=js&"
export * from "./liftrelay.vue?vue&type=script&lang=js&"
import style0 from "./liftrelay.vue?vue&type=style&index=0&id=bc2d36a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2d36a8",
  null
  
)

export default component.exports